import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/surveys')({
  component: () => (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-white mb-2 capitalize">surveys</h1>
      <p className="text-slate-400">Este módulo está em desenvolvimento.</p>
    </div>
  ),
})
